module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/clone.js
// module id = 52
// module chunks = 0